import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-md-10 ml-sm-auto pt-3 px-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 text-start" }
const _hoisted_4 = { class: "bold d-inline-block" }
const _hoisted_5 = {
  key: 0,
  class: "small text-muted"
}
const _hoisted_6 = {
  key: 1,
  class: "small"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "col-md-12 text-start" }
const _hoisted_10 = { class: "card p-2" }
const _hoisted_11 = { class: "table table-hover" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, " Orders - " + _toDisplayString(_ctx.ordersStore.showAllOrders === false ? "6 months" : "All"), 1),
        (!_ctx.isLoading && _ctx.orders)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(_ctx.orders.length) + ")", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, " Loading...")),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary float-end",
          disabled: _ctx.isLoading === true,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleGetOrders && _ctx.toggleGetOrders(...args)))
        }, _toDisplayString(_ctx.ordersStore.showAllOrders === false
              ? "Fetch all Orders"
              : "Fetch 6 months"), 9, _hoisted_7)
      ])
    ]),
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("table", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-start w-25" }, "Order date"),
                    _createElementVNode("th", { class: "text-start" }, "Order reference"),
                    _createElementVNode("th", { class: "text-start" }, "Project number"),
                    _createElementVNode("th", { class: "text-start" }, "Status"),
                    _createElementVNode("th", { class: "text-end w-25" }, "Total")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      style: {"cursor":"pointer"},
                      key: order?.orderNumber,
                      onClick: ($event: any) => (_ctx.goToOrderDetails(order))
                    }, [
                      _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.getFormattedOrderDate(order?.orderDate)), 1),
                      _createElementVNode("td", _hoisted_14, _toDisplayString(order.orderReference && order.orderReference), 1),
                      _createElementVNode("td", _hoisted_15, _toDisplayString(order.orderNumber && order.orderNumber), 1),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(order.orderStatus && _ctx.getOrderStatusText(order.orderStatus)), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.formatCurrency(
                      order?.subTotal,
                      _ctx.userStore.userInfo?.currency
                    )), 1)
                    ], 8, _hoisted_12))
                  }), 128)),
                  _cache[1] || (_cache[1] = _createElementVNode("tr", null, null, -1))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}